'use client'
import { openOnrampPopup } from '../openOnrampPopup.js';
import { providerDisplayModes } from '../onrampProviders/index.js';

/**
 * Converts an OnrampConfiguration to an OnrampOption based on the provider's display mode
 */
const onrampConfigurationToOnrampOption = (provider, onClick, setShowOnramp) => {
    var _a, _b, _c, _d;
    // Determine if this provider uses popup or iframe mode
    const providerKey = provider.provider;
    const openMode = (_a = providerDisplayModes[providerKey]) !== null && _a !== void 0 ? _a : 'iframe';
    // Create common properties
    const baseProperties = {
        displayName: (_c = (_b = provider.name) !== null && _b !== void 0 ? _b : provider.provider) !== null && _c !== void 0 ? _c : '',
        iconUrl: (_d = provider.iconUrl) !== null && _d !== void 0 ? _d : '',
        id: String(provider.provider),
        openMode,
        url: provider.url,
    };
    // Create base onClick handler
    const baseOnClick = (params) => {
        onClick({
            onrampProvider: provider.provider,
        });
    };
    // For popup mode, enhance the onClick handler to open the popup
    if (openMode === 'popup') {
        return Object.assign(Object.assign({}, baseProperties), { onClick: (params) => {
                baseOnClick();
                if (provider.url && setShowOnramp) {
                    openOnrampPopup(provider.url, params.wallet, setShowOnramp, provider.provider);
                }
            } });
    }
    // For iframe mode, use the base onClick handler
    return Object.assign(Object.assign({}, baseProperties), { onClick: baseOnClick });
};

export { onrampConfigurationToOnrampOption };
